import React, { useState } from 'react';
import './SalarieForm.css';

const SalarieForm = ({ onSubmit, initialData, onCancel }) => {
  const [formData, setFormData] = useState({
    matricule: initialData?.matricule || '',
    nom: initialData?.nom || '',
    taux_horaire: initialData?.taux_horaire || '',
    acamion: initialData?.acamion || false
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.matricule.trim()) {
      newErrors.matricule = 'Matricule is required';
    }
    
    if (!formData.nom.trim()) {
      newErrors.nom = 'Nom is required';
    }
    
    if (formData.taux_horaire && isNaN(parseFloat(formData.taux_horaire))) {
      newErrors.taux_horaire = 'Taux horaire must be a valid number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    if (typeof onSubmit !== 'function') {
      console.error('onSubmit is not a function');
      setErrors({ submit: 'Form submission handler is not available' });
      return;
    }

    setIsSubmitting(true);
    
    try {
      const submitData = {
        ...formData,
        taux_horaire: parseFloat(formData.taux_horaire) || 0
      };
      
      await onSubmit(submitData);
      
      // Reset form if it's a new entry (no initialData)
      if (!initialData) {
        setFormData({
          matricule: '',
          nom: '',
          taux_horaire: '',
          acamion: false
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setErrors({ submit: 'Failed to save salarie. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="salarie-form-container">
      <form onSubmit={handleSubmit} className="salarie-form">
        <h3>{initialData ? 'Modifier Salarié' : 'Ajouter Salarié'}</h3>
        
        <div className="form-content">
          {errors.submit && (
            <div className="error-message">{errors.submit}</div>
          )}

          <div className="form-group">
            <label htmlFor="matricule">Matricule *</label>
            <input
              type="text"
              id="matricule"
              name="matricule"
              value={formData.matricule}
              onChange={handleChange}
              className={errors.matricule ? 'error' : ''}
              disabled={isSubmitting}
              placeholder="Entrez le matricule"
            />
            {errors.matricule && <span className="error">{errors.matricule}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="nom">Nom *</label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              className={errors.nom ? 'error' : ''}
              disabled={isSubmitting}
              placeholder="Entrez le nom complet"
            />
            {errors.nom && <span className="error">{errors.nom}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="taux_horaire">Taux Horaire (€)</label>
            <input
              type="number"
              step="0.01"
              id="taux_horaire"
              name="taux_horaire"
              value={formData.taux_horaire}
              onChange={handleChange}
              className={errors.taux_horaire ? 'error' : ''}
              disabled={isSubmitting}
              placeholder="0.00"
            />
            {errors.taux_horaire && <span className="error">{errors.taux_horaire}</span>}
          </div>

          <div className="checkbox-group">
            <label>
              <input
                type="checkbox"
                name="acamion"
                checked={formData.acamion}
                onChange={handleChange}
                disabled={isSubmitting}
              />
              A camion
            </label>
          </div>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            onClick={onCancel}
            className="btn-cancel"
            disabled={isSubmitting}
          >
            Annuler
          </button>
          <button 
            type="submit" 
            className="btn-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Enregistrement...' : (initialData ? 'Modifier' : 'Ajouter')}
          </button>
        </div>
      </form>
    </div>
  );
};

SalarieForm.defaultProps = {
  onSubmit: () => console.log('Default onSubmit called'),
  onCancel: () => console.log('Default onCancel called'),
  initialData: null
};

export default SalarieForm;
